import $ from 'jquery';
require('./shared/layout');

window.addEventListener("load", function () {

  var inputs = $('.form_input input[data-input]')
  var selects = $('.form_input select[data-input]')

  var est_hash = {
    freq: 0,
    viewers: 0,
    duration: 0,
    bitrate: 0,
    watchtime: 1,
    monthlyviewers: 0,
    avgwatch: 0
  }

  inputs.each(function (i, input) {
    var el = $(input)
    var prop = input.dataset.input
    est_hash[prop] = Number(this.value)

    var oninputchanged = function () {
      // var prop = this.dataset.input
      var value = Number(this.value)
      est_hash[prop] = value
      onchange()
      // console.log('input', this.value)
    }
    el.on('change', oninputchanged)
    el.on('keypress', oninputchanged)
    el.on('keyup', oninputchanged)
  })

  selects.each(function (i, input) {
    var el = $(input)
    var prop = input.dataset.input
    est_hash[prop] = Number(this.value)
    el.on('change', function () {
      // var prop = this.dataset.input
      var value = Number(this.value)
      est_hash[prop] = value
      onchange()
      // console.log('select', this.value)
    })
  })

  // Quality preset: fills the bitrate field behind the scenes
  var qualityPreset = $('select[data-quality-preset]')
  var bitrateInput = $('input[data-input="bitrate"]')
  var presetGuard = false

  qualityPreset.on('change', function () {
    if (this.value === 'custom') return
    presetGuard = true
    bitrateInput.val(Number(this.value))
    bitrateInput.trigger('change')
    presetGuard = false
  })

  // Manually edited bitrate means the preset no longer applies
  bitrateInput.on('change keyup', function () {
    if (!presetGuard) qualityPreset.val('custom')
  })

  // Prefill from ?bitrate= (e.g. arriving from the bitrate calculator)
  var urlBitrate = Number(new URLSearchParams(window.location.search).get('bitrate'))
  if (urlBitrate > 0) {
    est_hash.bitrate = urlBitrate
    bitrateInput.val(urlBitrate)
    qualityPreset.val('custom')
  }

  setTimeout(onchange, 0);

  function toggleMode(is_live_247) {
    // 24/7 channels (web TV, news networks) are estimated from monthly
    // audience analytics; scheduled events from concurrent viewers.
    $('[data-mode="event"]').toggleClass('bwc-hidden', is_live_247)
    $('[data-mode="live"]').toggleClass('bwc-hidden', !is_live_247)
  }

  function onchange() {
    var is_live_247 = est_hash['freq'] === -1
    toggleMode(is_live_247)

    // calc usage
    var watch_factor = est_hash.watchtime > 0 ? est_hash.watchtime : 1
    var bytes_per_sec = (est_hash.bitrate * 1000) / 8
    var bytes, minutes

    if (is_live_247) {
      // monthly visits x average watch time per visit
      minutes = est_hash.monthlyviewers * est_hash.avgwatch
      bytes = bytes_per_sec * minutes * 60
    } else {
      minutes = est_hash.viewers * est_hash.freq * est_hash.duration * watch_factor
      bytes = bytes_per_sec * est_hash.viewers * est_hash.freq * est_hash.duration * 60 * watch_factor
    }

    minutes = Math.round(minutes)

    var unit = 'GB'
    var usage = bytes / Math.pow(1000, 3)
    if (usage > 1000) {
      unit = 'TB'
      usage = Number((usage / 1000).toFixed(3))
    } else {
      usage = Number(usage.toFixed(2))
    }

    var usageBandwidthEL = $('[data-result-usage="bandwidth"]')
    $('[data-value]', usageBandwidthEL).text(usage)
    $('[data-unit]', usageBandwidthEL).text(unit)

    var usageMinsEL = $('[data-result-usage="minutes"]')
    $('[data-value]', usageMinsEL).text(minutes.toLocaleString('en-US'))

    choosePlan(bytes, usage, unit, minutes)
  }

  function choosePlan(bytes, usage, unit, minutes) {
    // Live stream hosting plans (annual-billing monthly rates).
    // Keep in sync with /pricing/live-stream-hosting/
    var plans = [
      {
        "name": "Events Plan",
        "cost": 49,
        "bytes": 1000*Math.pow(1000,3) // 1 TB / month
      },
      {
        "name": "Studio Plan",
        "cost": 119,
        "bytes": 3000*Math.pow(1000,3) // 3 TB / month
      },
      {
        "name": "Network Plan",
        "cost": 339,
        "bytes": 8000*Math.pow(1000,3) // 8 TB / month
      }
    ]

    var planSuggested = null
    for (const plan of plans) {
      if (bytes <= plan.bytes) {
        planSuggested = plan
        break;
      }
    }

    var platCostRecommendationEl = $('[data-recommendation-cost]')
    var platNameRecommendationEl = $('[data-recommendation-plan]')
    if (planSuggested) {
      $('[data-value]', platNameRecommendationEl).text(planSuggested.name)
      $('[data-value]', platNameRecommendationEl).show()

      $('[data-value]', platCostRecommendationEl).text(planSuggested.cost)
      $('[data-unit]', platCostRecommendationEl).show()
      $('[data-unit].unit-alt', platCostRecommendationEl).text('per month')

      $("#calculator_cta").show()
      $("#calculator_cta_alt").hide()
    } else {
      // Usage exceeds the Network plan bandwidth quota: recommend Enterprise
      $('[data-value]', platNameRecommendationEl).text('Enterprise')
      $('[data-value]', platNameRecommendationEl).show()

      $('[data-value]', platCostRecommendationEl).text('Custom')
      $('[data-unit].value2x', platCostRecommendationEl).hide() // hide the "$"
      $('[data-unit].unit-alt', platCostRecommendationEl).text('pricing')
      $('[data-unit].unit-alt', platCostRecommendationEl).show()

      // Prefill the Intercom conversation with the computed estimate
      var enterpriseMessage = "Hi Livepush team, I'm interested in an Enterprise live streaming plan. " +
        "The bandwidth calculator estimates our usage at about " + usage + " " + unit + " per month " +
        "(" + minutes.toLocaleString('en-US') + " viewing minutes). " +
        "Can we discuss pricing, bandwidth, and setup?"
      $("#calculator_cta_alt a").attr('data-intercom-message', enterpriseMessage)

      $("#calculator_cta").hide()
      $("#calculator_cta_alt").show()
    }
  }
});

